import { config } from 'src/config'
import { graphQLClient } from 'src/data/graphql/graphql-client'
import { CollectionSlugsDocument } from 'src/data/graphql-generated'
import { getLanguageFromLocale } from 'src/functions/i18n/localeFns'
import { getMetafield } from 'src/functions/util/getMetafield'
import { ProductCollectionPage, getStaticProps } from 'src/pages/[lang]/c/[slug]'

import type { GetStaticPaths } from 'next'
import type { CollectionSlugsQuery } from 'src/data/graphql-generated'
import type { Locale } from 'src/enum/Locale'

const getStaticPaths: GetStaticPaths = async () => {
  const paths: string[] = []
  const langs = config.locales.map((locale) => getLanguageFromLocale(locale as Locale))

  await Promise.all(
    langs.map(async (lang) => {
      const { collections }: CollectionSlugsQuery = await graphQLClient.request({
        document: CollectionSlugsDocument,
        variables: { lang: lang.toUpperCase() },
      })

      collections.nodes.forEach((collection) => {
        if (getMetafield(collection.metafields, 'layout', 'page_type') === 'gear') {
          paths.push(`/${lang}/g/${collection.handle}`)
        }
      })
    }),
  )

  return {
    paths,
    fallback: false,
  }
}

export { getStaticPaths, getStaticProps }

export default ProductCollectionPage
